var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c(
        "div",
        {
          staticClass: "contact-property-selector-inline",
          class: {
            "contact-property-selector-inline--agent":
              _vm.property && _vm.property.type === "agent",
          },
        },
        [
          _vm.property.type === "dropdown"
            ? [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.cloneValue,
                      callback: function ($$v) {
                        _vm.cloneValue = $$v
                      },
                      expression: "cloneValue",
                    },
                  },
                  _vm._l(_vm.property.options, function (option) {
                    return _c(
                      "a-select-option",
                      { key: option, attrs: { value: option } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(option) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ]
            : _vm.property.type === "agent"
            ? [
                _c("AgentPicker", {
                  attrs: { single: true, value: _vm.agentPickerValue },
                  on: { input: _vm.onAgentPickerInput },
                }),
              ]
            : [
                _c("a-input", {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.cloneValue,
                    callback: function ($$v) {
                      _vm.cloneValue = $$v
                    },
                    expression: "cloneValue",
                  },
                }),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }